@if (orders === null) {
  <loading-indicator [loadingMessage]="'Loading orders, please wait...'"></loading-indicator>
}

@if (orders !== null && filteredOrders.length === 0) {
  <div class="esign-empty-state">
    <i class="fas fa-file-signature"></i>
    <p>No e-signature orders found.</p>
  </div>
}

@if (filteredOrders.length > 0) {
  <div class="esign-envelope-list">
    @for (order of filteredOrders; track order.documentSigningOrderId) {
      <!-- Envelope row (clickable to expand) -->
      <div class="esign-envelope" [class.expanded]="isExpanded(order)"
           (click)="toggleOrder(order)">
        <div class="envelope-header">
          <div class="envelope-header-left">
            <i class="fas fa-chevron-right expand-icon" [class.rotated]="isExpanded(order)"></i>
            <div class="envelope-info">
              <span class="envelope-date">{{ order.dateInserted | date:'MMM d, yyyy h:mm a' }}</span>
              @if (redactEnvelopeId) {
                @let description = getDescription(order);
                @if (description) {
                  <span class="envelope-description">{{ description }}</span>
                }
              } @else {
                <span class="envelope-id">Envelope: {{ order.thirdPartyOrderId | slice:0:8 }}...</span>
              }
            </div>
          </div>
          <div class="envelope-header-right">
            <span class="status-badge" [ngClass]="getStatusBadgeClass(order.status)">
              {{ order.status }}
            </span>
            @if (order.loanDocTasks && order.loanDocTasks.length > 0) {
              <button class="btn btn-sm btn-view-doc"
                (click)="onViewSignedDocClicked(order, $event)"
                [disabled]="docLoadingStatuses.get(order.documentSigningOrderId)">
                @if (docLoadingStatuses.get(order.documentSigningOrderId)) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                } @else {
                  <i class="fas fa-file-pdf"></i>
                }
                <span class="btn-text">View Document</span>
              </button>
            }
          </div>
        </div>

        <!-- Pizza tracker progress bar -->
        <div class="pizza-tracker">
          @for (step of trackerSteps; track step; let i = $index) {
            <div class="tracker-step" [ngClass]="getStepClass(order, i)">
              <div class="step-dot">
                @if (getStepClass(order, i) === 'step-complete') {
                  <i class="fas fa-check"></i>
                } @else if (getStepClass(order, i) === 'step-error') {
                  <i class="fas fa-times"></i>
                }
              </div>
              <span class="step-label">{{ step }}</span>
            </div>
            @if (i < trackerSteps.length - 1) {
              <div class="tracker-connector" [ngClass]="getStepClass(order, i + 1)"></div>
            }
          }
        </div>
      </div>

      <!-- Expanded detail section -->
      @if (isExpanded(order)) {
        <div class="envelope-details">
          <!-- Recipients section -->
          @if (order.recipients && order.recipients.length > 0) {
            <div class="detail-section">
              <h6 class="detail-section-title">
                <i class="fas fa-users me-2"></i>Recipients ({{ order.recipients.length }})
              </h6>
              <div class="recipients-list">
                @for (recipient of order.recipients; track recipient.documentSigningRecipientId) {
                  <div class="recipient-row">
                    <div class="recipient-info">
                      <i [class]="getRecipientStatusIcon(recipient.status)"
                         [ngClass]="getRecipientStatusClass(recipient.status)"></i>
                      <div class="recipient-details">
                        <span class="recipient-name">{{ recipient.name }}</span>
                        <span class="recipient-email">{{ recipient.email }}</span>
                      </div>
                    </div>
                    <div class="recipient-meta">
                      <span class="recipient-type">{{ recipient.recipientType }}</span>
                      <span class="recipient-status" [ngClass]="getRecipientStatusClass(recipient.status)">
                        {{ recipient.status }}
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Order details section -->
          <div class="detail-section">
            <h6 class="detail-section-title">
              <i class="fas fa-info-circle me-2"></i>Order Details
            </h6>
            <div class="order-details-grid">
              @if (!redactEnvelopeId) {
                <div class="detail-item">
                  <span class="detail-label">Envelope ID</span>
                  <span class="detail-value">{{ order.thirdPartyOrderId }}</span>
                </div>
              }
              <div class="detail-item">
                <span class="detail-label">Added On</span>
                <span class="detail-value">{{ order.dateInserted | date:'MMM d, yyyy h:mm a' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Signing Through Email</span>
                <span class="detail-value">{{ order.signingLinkSentInEmail ? 'Yes' : 'No' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Status</span>
                <span class="detail-value">{{ order.status }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
